import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";
import React, { useState } from "react";

function ImageToBase() {
  const [baseImage, setBaseImage] = useState(null);
  const [copy, setCopy] = useState(false);
  const [model, setModel] = useState(true);

  const handleFileInputChange = (e) => {
    setCopy(false);
    setModel(false);
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setBaseImage(reader?.result);
    };
    reader.onerror = (error) => {};
  };

  const image_to_base64 = (image) => {
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let ctx = canvas.getContext("2d");
    ctx?.drawImage(image, 0, 0);
    let dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  };

  return (
    <>
      {baseImage === undefined && (
        <div className="image-cropper-box-design-upload">
          <div className="icon-center-alignment">
            <i className="fa-solid fa-cloud-arrow-up"></i>
          </div>
          <p>
            Drag your image here, or click to <strong>browse</strong>
          </p>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileInputChange(e)}
          />
        </div>
      )}

      {baseImage !== undefined && (
        <>
          <div className="counter-details-box">
            <img src={baseImage} alt="" width={500} height={500} />
          </div>

          <div className="main-globally-counter-box">
            <div className="copy-textarea-icon-alignment">
              <FiCopy onClick={() => handleCopy(baseImage)} />
              {copy && baseImage && (
                <div>
                  {" "}
                  <span>Copied</span>
                </div>
              )}
            </div>
            <div className="counter-text-area">
              <textarea value={baseImage} disabled />
            </div>
          </div>
          <div className="button counter-word-center-align">
            <button
              onClick={() => {
                setBaseImage(undefined);
              }}
            >
              <i className="fa-sharp fa-solid fa-arrow-left"></i> Back to site
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default ImageToBase;
